import React from 'react';
import NavButton from 'components/NavButton';
import { withRouter } from 'react-router-dom';
import NestedNavMenu from './NestedNavMenu';
import LinkHash from 'components/LinkHash';

const AppBarNavList = ({ history, navItems }) => {
  const onClickNav = route => {
    history.push(route);
  };
  return (
    <>
      {navItems.map(navItem =>
        navItem.subNavs ? (
          <NestedNavMenu key={navItem.text} navItem={navItem} onClickNav={onClickNav} />
        ) : navItem.route.includes('#') ? (
          <LinkHash key={navItem.text} route={navItem.route}>
            <NavButton>{navItem.text}</NavButton>
          </LinkHash>
        ) : (
          <NavButton key={navItem.text} onClick={() => onClickNav(navItem.route)}>
            {navItem.text}
          </NavButton>
        )
      )}
    </>
  );
};

export default withRouter(AppBarNavList);
